import { INSTALLMENT_LIST, DELETE_INSTALLMENT, UPDATE_INSTALLMENT_PLAN, CREATE_INSTALLMENT_SCHEDULE } from 'src/actions/types';
import _ from 'lodash';
const INITIAL_STATE = {data: {},paginate: {}}

export default (state=INITIAL_STATE, action) => {
  switch (action.type) {
    case INSTALLMENT_LIST:
      const paginate = _.omit(action.payload, 'data');
      return { ...state, data:_.mapKeys(action.payload.data, 'id'), paginate }
    case UPDATE_INSTALLMENT_PLAN:
      return {...state, data:{...state.data, [action.payload.id]:action.payload } }
    case DELETE_INSTALLMENT:
      return {...state, data:_.omit(state.data, action.payload)};
    default:
      return state;
  }
}